import React from 'react';
import SectionHeader from './ui/SectionHeader';

const Education = () => {
  const facts = [
    { label: 'Period', value: 'Aug 2013 - Sep 2017' },
    { label: 'Duration', value: '4 Years' },
    { label: 'GPA', value: '3.42 / 4.0' },
    { label: 'Location', value: 'Surabaya' },
  ];

  return (
    <section id="education" className="section-rule bg-btc-surface">
      <div className="container-max section-padding py-24">
        <SectionHeader
          number="04"
          label="Foundation"
          title="Education"
        />

        <div className="grid gap-6 lg:grid-cols-12">
          <div className="surface-card p-8 lg:col-span-5">
            <div className="inline-flex rounded-xl bg-white p-4">
              <img
                src="https://upload.wikimedia.org/wikipedia/id/thumb/9/9a/Logo_PPNS.png/250px-Logo_PPNS.png"
                alt="Politeknik Perkapalan Negeri Surabaya logo"
                className="h-24 w-24 object-contain"
              />
            </div>
            <p className="label mt-8">Institution</p>
            <h3 className="mt-2 max-w-xs font-heading text-2xl font-semibold leading-tight text-white">
              Politeknik Perkapalan Negeri Surabaya
            </h3>
          </div>

          <div className="surface-card p-8 md:p-12 lg:col-span-7">
            <p className="label">Degree</p>
            <p className="mt-2 font-heading text-2xl font-semibold leading-tight text-white md:text-3xl">
              Occupational Safety and Health
            </p>
            <p className="mt-3 text-sm text-btc-muted">Teknik Keselamatan dan Kesehatan Kerja</p>

            <div className="mt-10 grid grid-cols-2 gap-3">
              {facts.map((fact) => (
                <div key={fact.label} className="rounded-xl border border-white/10 p-5">
                  <p className="label">{fact.label}</p>
                  <p className="mt-1 font-mono text-sm text-white">{fact.value}</p>
                </div>
              ))}
            </div>

            <p className="label mt-8">Activities</p>
            <p className="mt-2 font-heading font-semibold text-white">
              Students Association (HIMATEK K3) 2014
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
